import type { ReactNode } from "react";
import { Controller } from "react-hook-form";

export const EmailPreferencesController = (props: {
  name: string;
  label: string;
  disabled?: boolean;
  /** Shown while checked; a parent `watch` misses the value after `reset` (shouldUnregister). */
  children?: ReactNode;
}) => {
  const { name, label, disabled, children } = props;

  return (
    <Controller
      name={name}
      render={({ field: { value, name, onChange }, fieldState: { error } }) => (
        <>
          <div className="form-group form-check mb-2">
            <input
              id={name}
              type="checkbox"
              className="form-check-input"
              checked={value}
              onChange={onChange}
              disabled={disabled}
            />
            <label className="form-check-label user-select-none" htmlFor={name}>
              {label}
            </label>
            {!!error && <div className="invalid-feedback">{error.message}</div>}
          </div>
          {!!value && children}
        </>
      )}
    />
  );
};
